import { render, staticRenderFns } from "./infoMobile.vue?vue&type=template&id=0b9d44bc&scoped=true"
import script from "./infoMobile.vue?vue&type=script&lang=js"
export * from "./infoMobile.vue?vue&type=script&lang=js"
import style0 from "./infoMobile.vue?vue&type=style&index=0&id=0b9d44bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9d44bc",
  null
  
)

export default component.exports